<template>
    <div style="font-size: 1rem;">
        <span class="badge badge-secondary" style="background-color: #ccc" v-show="task.comments_count > 0">
            <span style="font-size: .7rem;">{{ task.comments_count }}</span> 
            <span class="material-icons" style="font-size: inherit; vertical-align:top;">comment</span>
        </span>
        <span class="badge badge-secondary" style="background-color: #ccc" v-show="task.documents_count > 0">
            <span class="material-icons" style="font-size: inherit; vertical-align:top;">attach_file</span>
            <span style="font-size: .7rem;">{{ task.documents_count }}</span>
        </span>
        <span v-if="task.team" class="badge badge-secondary" style="display: inline-flex; align-items: center;">
<!--            <span :style="{ display: 'inline-block', marginRight: '4px', borderRadius: '7px', width: '7px', height: '7px', background:  task.team.colour && !task.completed_at ? task.team.colour : '#ccc' }"></span>-->
            <span>{{ task.team.name }}</span>
        </span>
        <span class="badge badge-secondary" style="background-color: #ccc;" v-show="task.inspection">
            <span class="material-icons" style="font-size: inherit; vertical-align:top;">search</span>
        </span>
        <span class="badge badge-secondary" v-if="task.is_warranty_claim">
            <!--Warranty!-->
            <span class="material-icons" style="font-size: inherit; vertical-align:top;" title="Warranty">error</span>
        </span>
        <span :class="'badge ' + (taskPassedDue ? 'badge-danger' : 'badge-secondary')" v-show="task.due_at && !task.completed_at">
            <span class="material-icons" style="font-size: inherit; vertical-align:top;">access_time</span>
        </span>
        <span class="badge badge-secondary" style="background-color: #ccc;" v-show="task.description && task.description.length > 0">
            <span class="material-icons" style="font-size: inherit; vertical-align:top;">format_align_justify</span>
        </span>
        <span :class="'badge badge-secondary'" v-show="task.expense_items_count > 0" title="> 1 cost assigned">
            <span class="material-icons" style="font-size: inherit; vertical-align:top;">attach_money</span>
        </span>
        <span :class="'badge badge-secondary'" v-show="task.consumables_count > 0" title="> 1 consumable assigned">
            <span class="material-icons" style="font-size: inherit; vertical-align:top;">opacity</span>
        </span>
        <span :class="'badge badge-secondary'" v-show="task.time_cards_count > 0" title="> 1 timesheet attached">
            <span class="material-icons" style="font-size: inherit; vertical-align:top;">timer</span>
        </span>
    </div>
</template>

<script>
    import Moment from 'moment'
    import { TaskSchema } from '../../classes/Api/Task'

    export default {
        props: {
            task: {
                type: Object,
                default() {
                    return new TaskSchema();
                }
            }
        },
        computed: {   
            taskPassedDue() {
                if (this.task.due_at) {
                    return (new Moment(this.task.due_at)).isBefore();
                }

                return false;
            },
        }
    }
</script>